<kl-form-container
  (onCloseAlert)="alertShow = false"
  (onCommitSave)="save()"
  [mode]="'edit'"
  [alertMessage]="alertMessage"
  alertType="error"
>
  <div class="button-group mb-2">
    <button class="btn btn-sm btn-bluefish" (click)="selectAll()">
      {{ "select_all" | translate }}
    </button>
    <button class="btn btn-sm btn-default" (click)="unSelectAll()">
      {{ "un_select_all" | translate }}
    </button>
  </div>
  <div class="col-lg-12 control-section custom-tree">
    <div class="control-wrapper">
      <div class="tree-data">
        <div class="content">
          <div class="tree-list">
            <div id="permissionTreeView"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</kl-form-container>
